/*
 * Patadog: scroll-triggered muted autoplay for product gallery video.
 * Dawn's native behavior requires a tap to play (by design, so sound can play
 * on that first click). This adds an Instagram-Reels-style layer on top:
 * the video auto-plays muted and looped once it's mostly in view, and a
 * small button lets the shopper tap for sound. Nothing here touches Dawn's
 * own deferred-media component — it only drives the same poster button
 * Dawn already renders.
 */
(function () {
  function attachMuteToggle(container, video) {
    if (container.querySelector('.reel-mute-toggle')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'reel-mute-toggle';
    btn.setAttribute('aria-label', 'Toggle video sound');
    btn.textContent = video.muted ? '🔇' : '🔊';
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      btn.textContent = video.muted ? '🔇' : '🔊';
    });
    container.appendChild(btn);
  }

  function setupReelAutoplay(container) {
    if (container.dataset.reelBound) return;
    container.dataset.reelBound = 'true';

    var deferred = container.querySelector('deferred-media');
    var poster = deferred && deferred.querySelector('.deferred-media__poster');
    if (!deferred) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = deferred.querySelector('video');

          if (entry.isIntersecting) {
            if (!video && poster) {
              poster.click();
              var attempts = 0;
              (function waitForVideo() {
                var v = deferred.querySelector('video');
                attempts += 1;
                if (v) {
                  v.muted = true;
                  v.playsInline = true;
                  v.loop = true;
                  v.play().catch(function () {});
                  attachMuteToggle(container, v);
                } else if (attempts < 60) {
                  requestAnimationFrame(waitForVideo);
                }
              })();
            } else if (video) {
              video.play().catch(function () {});
            }
          } else if (video) {
            video.pause();
          }
        });
      },
      { threshold: 0.6 }
    );

    observer.observe(container);
  }

  function init() {
    document
      .querySelectorAll(
        'media-gallery .product-media-container.media-type-video, media-gallery .product-media-container.media-type-external_video'
      )
      .forEach(setupReelAutoplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
